// src/pages/Workflows/components/WorkflowFilters.js

import React from 'react';

export default function WorkflowFilters({ filtro, setFiltro, pesquisa, setPesquisa, isAdmin }) {
  return (
    <div className="wf-filters">
      {isAdmin && (
        <div className="wf-toggle-group">
          {['todos', 'meus', 'partilhados'].map(opcao => (
            <button
              key={opcao}
              className={`wf-toggle-btn${filtro === opcao ? ' active' : ''}`}
              onClick={() => setFiltro(opcao)}
            >
              {opcao === 'todos' ? 'Todos' : opcao === 'meus' ? 'Meus' : 'Partilhados'}
            </button>
          ))}
        </div>
      )}
      <input
        type="text"
        className="wf-search-input"
        placeholder="Pesquisar workflows..."
        value={pesquisa}
        onChange={e => setPesquisa(e.target.value)}
      />
    </div>
  );
}
